export default {
  id: "saleTypeBreakdown",
  name: "",
  description: "",
  report: {
    name: "Sales breakdown",
    chartType: "PIE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: ["Sale.sale_type"],
      measures: ["Sale.count"],
      sort: {
        direction: "desc",
        by: "Sale.count",
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: true,
      points: false,
      colorTheme: "default",
    },
  },
};
